import { useEffect, useRef, useState } from "react";
import { msalInstance } from "./authConfig"; // Your MSAL configuration file

const useAutoLogout = (timeout = 30 * 60 * 1000) => { // Default 5 minutes
    const timeoutRef = useRef(null);
    const [timeLeft, setTimeLeft] = useState(timeout); // State to track time left

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setTimeLeft(timeout); // Reset the time left when activity is detected

        timeoutRef.current = setTimeout(() => {
            handleLogout();
        }, timeout);
    };

    const handleLogout = async () => {
        try {
            console.log("User is idle, logging out...");
            
            // Ensure MSAL is initialized
            await msalInstance.initialize();
            
            // Clear local storage
            localStorage.clear();
    
            // Perform logout and redirect
            // await msalInstance.logoutRedirect({
            //     postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`,
            // });
    
            // Reload the application after logout
            
            window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
        } catch (error) {
            console.error("MSAL logout failed:", error);
    
            // Fallback: If logout fails, clear storage and reload anyway
            localStorage.clear();
            window.location.reload();
        }
    };
    
    

    useEffect(() => {
        const activityEvents = ["click", "keydown", "mousedown", "touchstart"];

        const handleActivity = () => resetTimer();
        window.addEventListener("click", handleActivity);

        activityEvents.forEach((event) =>
            window.addEventListener(event, handleActivity)
        );

        resetTimer(); // Initialize timer on component mount

        return () => {
            clearTimeout(timeoutRef.current); // Clear timeout on unmount
            activityEvents.forEach((event) =>
                window.removeEventListener(event, handleActivity)
            );
        };
    }, [timeout]);

    useEffect(() => {
        // Start interval to log time left every second
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev > 1000) {
                    console.log(`Time left until auto-logout: ${Math.floor(prev / 1000)} seconds`);
                    return prev - 1000;
                }
                return 0;
            });
        }, 1000);

        return () => clearInterval(interval); // Clear interval on unmount
    }, []);

    return null; // Hook does not render anything
};

export default useAutoLogout;
